module.exports = __webpack_public_path__ + "img/ball_4.a80eff08.png";